import "./bootstrap";

// Below was their default.js
import "./default";

// Mix

const isDev = location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "staging.wmp.nl";
 if (!isDev) 
    {
    require("./cookieconsent-init");
    }
